/* eslint-disable react/display-name */
import { Typography } from "@mui/material";
import AddBox from "@mui/icons-material/AddBox";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import Check from "@mui/icons-material/Check";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import Clear from "@mui/icons-material/Clear";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import Edit from "@mui/icons-material/Edit";
import FilterList from "@mui/icons-material/FilterList";
import FirstPage from "@mui/icons-material/FirstPage";
import HomeIcon from "@mui/icons-material/Home";
import LastPage from "@mui/icons-material/LastPage";
import Remove from "@mui/icons-material/Remove";
import SaveAlt from "@mui/icons-material/SaveAlt";
import Search from "@mui/icons-material/Search";
import ViewColumn from "@mui/icons-material/ViewColumn";
import PSnakbar from "../../../components/pos/PSnakbar";
import db from "../../../db/db";
import React, { forwardRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import AccountingsettingsCrud from "./AccountingsettingsCrud.jsx";
import MaterialTable from "@material-table/core";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export default function AccountingsettingsList(props) {
  console.log("tttt ledger_delete", props.context.privileges.ledger_delete);
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [searchStr, setSearchStr] = useState("");
  const [treeData, setTreeData] = useState("");
  const [searchData, setSaerchData] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  var biRef = {};

  function addAccountingsettings(id, code, type, level, mode) {
    biRef.child.showAccountingsettingsCrudWindow(id, code, type, level, mode);
  }

  function onEditClicked(rowId, mode) {
    biRef.child.showAccountingsettingsCrudWindow(rowId, null, null, null, mode);
  }

  async function loadData() {
    loadByRest();
    //loaadByDB();
  }

  async function loadByRest() {
    setTreeData([]);
    setIsLoading(true);

    const result = await API.get("/api/v1/ledgertree");
    setTreeData(result.data);

    /* var arr = result.headers["content-range"].split("/");

    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data);
    setIsLoading(false);*/
  }

  async function loaadByDB() {
    db.accountingsettings.toArray(function (data) {
      setData(data);
    });
  }
  function accountingsettingsListRefresh() {
    loadData();
  }

  const tableRef = React.useRef();

  function isEditable() {
    return props.context.privileges.ledger_edit && true;
  }

  return (
    <div>
      <AccountingsettingsCrud
        biRef={biRef}
        onRefresh={accountingsettingsListRefresh}
        showMessage={props.showMessage}
        context={props.context}
      ></AccountingsettingsCrud>

      {
        <MaterialTable
          tableRef={tableRef}
          icons={tableIcons}
          title={translate("Chart Of Accounts")}
          data={treeData}
          columns={[
            {
              title: translate("Name"),
              field: "name",
              cellStyle: (rowDataArray, rowData) => {
                return {
                  paddingLeft: 15 * rowData.level,
                  cellWidth: "15%",
                };
              },
              align: "left",
            },
          ]}
          actions={[
            {
              icon: () => (
                <Typography variant="body1" color="secondary">
                  <b> Sub Ledger </b>
                  <sup style={{ color: "red" }}>+</sup>
                </Typography>
              ),
              tooltip: translate("New Sub Ledger"),
              isFreeAction: true,
              onClick: (event) =>
                addAccountingsettings(null, null, "subledger", null, "create"),
              hidden: !isEditable(),
            },

            (rowData) => ({
              icon: () => (
                <Typography variant="body1">
                  <b> Group </b>
                  <sup style={{ color: "red" }}>+</sup>
                </Typography>
              ),
              tooltip: translate("New chart"),
              onClick: (event, rowData) => {
                addAccountingsettings(
                  rowData.id,
                  rowData.code,
                  "chart",
                  rowData.level,
                  "create"
                );
              },
              hidden:
                !isEditable() ||
                (rowData.ledgerFlag || rowData.level >= 2 ? true : false),
            }),

            (rowData) => ({
              icon: () => (
                <Typography variant="body1" color="primary">
                  <b> Ledger </b>
                  <sup style={{ color: "red" }}>+</sup>
                </Typography>
              ),
              tooltip: translate("New Ledger"),
              onClick: (event, rowData) =>
                addAccountingsettings(
                  rowData.id,
                  rowData.code,
                  "ledger",
                  rowData.level,
                  "create"
                ),
              hidden:
                !isEditable() ||
                (rowData.level == 0 || rowData.ledgerFlag ? true : false),
            }),
            (rowData) => ({
              icon: () => (
                <Typography variant="body1" color="secondary">
                  <b>
                    {/* {(!rowData.ledgerFlag &&
                      props.context.privileges.ledger_edit) ||
                    (rowData.ledgerFlag &&
                      props.context.privileges.ledger_opening_balance_update) */}
                    {isEditable(rowData)
                      ? translate("Edit")
                      : translate("View")}
                  </b>
                </Typography>
              ),
              tooltip:
                // (!rowData.ledgerFlag && props.context.privileges.ledger_edit) ||
                // (rowData.ledgerFlag &&
                //   props.context.privileges.ledger_opening_balance_update)
                isEditable(rowData) ? translate("Edit") : translate("View"),
              onClick: (event, rowData) => {
                onEditClicked(
                  rowData.id,
                  isEditable(rowData) ? "edit" : "view"
                  // "edit"
                  // (!rowData.ledgerFlag &&
                  //   props.context.privileges.ledger_edit) ||
                  //   (rowData.ledgerFlag &&
                  //     props.context.privileges.ledger_opening_balance_update)
                );
              },
              hidden: !rowData.editable,
            }),
          ]}
          parentChildData={(row, rows) =>
            rows.find((a) => a.id === row.parentId)
          }
          options={{
            search: true,
            tableLayout: "auto",
            header: true,
            maxBodyHeight: getWindowDimensions().height - 180,
            paging: false,
            actionsColumnIndex: 1,
            actionsCellStyle: () => ({
              display: "flex",
              width: "100%",
            }),
            rowStyle: (rowData) => ({
              backgroundColor: rowData.ledgerFlag ? "#F0F8FF" : "white",
            }),
          }}
        />
      }
      <PSnakbar biRef={biRef}></PSnakbar>
    </div>
  );
}
